import { useOpportunityCreate } from "./useOpportunityCreate";
import { useOpportunityAdvance } from "./useOpportunityAdvance";
import { useOpportunityClose } from "./useOpportunityClose";

export function useOpportunityOps() {
  const { handleOpportunitySubmit } = useOpportunityCreate();
  const { handleAdvanceStage } = useOpportunityAdvance();
  const { handleCloseLost } = useOpportunityClose();

  return {
    handleOpportunitySubmit,
    handleAdvanceStage,
    handleCloseLost,
  };
}
